import { useMedia } from "react-use";

export const useIsMobile = () => {
  const isMobile = useMedia("(max-width: 768px)", false);
  return isMobile;
};

export const useIsTablet = () => {
  const isTablet = useMedia(
    "(min-width: 769px) and (max-width: 1024px)",
    false,
  );
  return isTablet;
};

export const useIsDesktop = () => {
  const isDesktop = useMedia("(min-width: 1025px)", false);
  return isDesktop;
};

export const useIsSmallScreen = () => {
  const isSmallScreen = useMedia("(max-width: 1024px)", false);
  return isSmallScreen;
};
